import { render, staticRenderFns } from "./Invoice-card-home.vue?vue&type=template&id=c2cea65a&scoped=true"
import script from "./Invoice-card-home.vue?vue&type=script&lang=js"
export * from "./Invoice-card-home.vue?vue&type=script&lang=js"
import style0 from "./Invoice-card-home.vue?vue&type=style&index=0&id=c2cea65a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2cea65a",
  null
  
)

export default component.exports